import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import OrderSumary from './OrderSumary';
import Homedelivery from '../../Assetes/Images/honedelivery.png'
import { connect, useDispatch, useSelector } from 'react-redux';
import { handleSpecialInstruction } from '../../Redux';
import _ from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import Header from '../../Components/Header';
import jwt_decode from 'jwt-decode';
import cartoon from '../../Assetes/Images/Delivery.png'
import pickup from '../../Assetes/Images/pickup.png'
import { toast } from 'react-toastify';
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { PICKUP_TIME } from '../../Redux/actions/paymentTypes';
import pin from "../../Assetes/Images/kfc-new-pin.png"
import pin2 from "../../Assetes/Images/pin-red.png"
import domPurify from "../../Components/dompurify";
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone } from '../../lib';

function PaymentMethod(props: any) {
    const orderType = useSelector((state: any) => state.payment.orderType);
    const store = useSelector((state: any) => state.store.storeSelected);
    const delivery_address = useSelector((state: any) => state.payment.delivery_address);
    const cartData = useSelector((state: any) => state.cart.cartData);
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const socialLogin = useSelector((state: any) => state.customer.socialLogin);
    const guestInfo = useSelector((state: any) => state.customer.guestInfo);
    const history = useHistory();
    const [headerUpdate, setHeaderUpdate] = useState(0);
    const [user_name, setUser_name] = useState('')
    const [phone_number, setPhone_number] = useState('')
    const [pickup_time, setPickup_time] = useState(15);
    const dispatch = useDispatch();
    const lang = useCurrentLocale();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (cartData.length <= 0) {
            history.push(`/${lang}/menu`);
        }
        else if (isLogged || guestInfo) {
            let token: any = localStorage.getItem("userToken")
            let phone: any = sessionStorage.getItem("guestphone")
            let name: any = sessionStorage.getItem("guestName")
            if (socialLogin) {
                let decoded: any = jwt_decode(token);
                if (!checkPhone(decoded.customer.phone_number?.split("-")[1])) {
                    toast.error(t("UPDATE_YOUR_PROFILE_INFORMATION"));
                    history.push(`/${lang}/my-details`);
                }
            }
            if (token) {
                let decoded: any = jwt_decode(token);
                setPhone_number(decoded.customer.phone_number)
                let name = decoded.customer?.first_name + " " + decoded.customer?.last_name
                setUser_name(name)
            }
            else if (phone) {
                setPhone_number(phone)
                setUser_name(name);
            }
        }
        else {
            history.push(`/${lang}/menu`);
        }

    }, [])

    const handleTime = (e: any) => {
        dispatch({
            type: PICKUP_TIME,
            time: e.target.value
        });
        setPickup_time(e.target.value);
    }

    useEffect(() => {
        dispatch({
            type: PICKUP_TIME,
            time:15
        });
    },[])
    const { t } = useTranslation();

    return (
        <div className='payment-cotainer'>
            <Header headerUpdate={headerUpdate} />
            <div className='kfc-order'>
                <div className="container-xxl category-container-custom mt-120 mb-md-100">
                 
                    <div className="row">
                        <div className="col-lg-8">
                            <div className='payment-method'>
                                <div>
                                    <h5 className='your-text d-flex align-items-center gap-10'>
                                        <Link className='back-btn' to={`/${lang}/menu${window.location.search}`}>
                                            <i className="ri-arrow-left-s-line arrow-dir"></i>
                                        </Link>
                                        <span>{t("YOUR_INFORMATION")}</span></h5>
                                </div>
                                <div className='contact-container'>
                                    <div className='contact-name'>{user_name}</div>
                                    <div className='contact-number d-flex gap-10'>
                                        <i className="ri-phone-line contact-name"></i>
                                        <span className='contact-name contact-number-ar'>{phone_number}</span>
                                      
                                    </div>
                                </div>
                                {(!_.isEmpty(store) && orderType && orderType == "Delivery") ?
                                    <div className='contact-container'>
                                        <div>
                                            <div className='payment-order-option'>
                                                <img src={cartoon} alt="" />
                                                <div>
                                                    <h6>{t("DELIVERY_FROM")}</h6>
                                                    <p className='mb-0 store-name-payment'>{store && store.store_name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <div className='contact-container d-block'>
                                            <div className="row">
                                                <div className='col-md-4 payment-order-option'>
                                                    <img src={pickup} alt="" />
                                                    <div>
                                                        <h6>{t("PICKUP_FROM")}</h6>
                                                        <p className='mb-0 store-name-payment'>{store && store.store_name}</p>
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-4 offset-md-4">
                                                <FormControl className='field-style' variant="filled" color="error">
                                                    <InputLabel id="demo-simple-select-filled-label">Pickup Time</InputLabel>
                                                        <Select
                                                            value={pickup_time}
                                                            onChange={handleTime}
                                                        labelId="demo-simple-select-filled-label"
                                                        id="demo-simple-select-filled"
                                                        name="gender"
                                                        className='field-style'
                                                    >
                                                        <MenuItem value={15}>15 min</MenuItem>
                                                        <MenuItem value={30}>30 min</MenuItem>
                                                        <MenuItem value={45}>45 min</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div> */}
                                            </div>
                                        </div>
                                    </>
                                }
                              
                                {(!_.isEmpty(store) && orderType && orderType == "Delivery") && <div className="kfc-order-container p-3 mt-4">

                                    <div className='d-flex justify-content-between align-items-baseline'>
                                        <div className='contact-name pb-3'>{t("WE_WLL_DELIVER_YOUR_ORDER_HERE")}</div>
                                    
                                    </div>
                                    <div className='d-flex align-items-center gap-10'>
                                        <img className='home-delivery' src={pin2} alt="" />
                                        <div>
                                            <Button className='kfc-addres-btn' variant="contained" color="error">
                                                {t("ADDRESS")}
                                            </Button>
                                            <p className='mb-0'>{delivery_address !== "" ? `${domPurify.sanitize(delivery_address)}` : <>{t("PLEASE_SELECT_LOCATION_FIRST")}</>}</p>
                                        </div>
                                    </div>
                                   
                                </div>
                                }

                            </div>
                        </div>
                        <div className="col-lg-4">
                            <OrderSumary setHeaderUpdate={setHeaderUpdate} headerUpdate={headerUpdate} />
                        </div>
                    </div>
                </div>
            </div >
        </div>
    )
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        handleSpecialInstruction: (event: any) => {
            dispatch(handleSpecialInstruction(event));
        }

    };
};

export default connect(null, mapDispatchToProps)(PaymentMethod);
